import { memo, useMemo } from 'react';
import { useGetBonuses, useGetLocalTournaments, useGetProviderTournaments } from 'react-easyrocket';
import { HeaderBurgerIcon } from 'src/svg/HeaderBurgerIcon';
import { useDrawer } from 'src/hooks/useDrawer';
import { headerNavigationData } from '../config';
import { HeaderNavigationItem } from './HeaderNavigationItem';
import { RoutesType } from 'src/router/hooks/useRoute';
import { useWindowSize } from 'src/modules/store/windowSizeStore';

const _HeaderNavigation = () => {
  const { is1280 } = useWindowSize('is1280');
  const { openLeftDrawer } = useDrawer();

  const { data: visibleBonuses, isFetched } = useGetBonuses();
  const countOfTournaments = useGetCountOfTournaments();

  const getCounerValue = (path: RoutesType): number | undefined => {
    switch (path) {
      case 'BONUSES':
        return isFetched ? visibleBonuses.length : undefined;
      case 'TOURNAMENTS':
        return countOfTournaments;
      default:
        return 0;
    }
  };

  return (
    <div className="flex justify-center items-center gap-2">
      <HeaderBurgerIcon
        className="[&_path]:fill-n_burger_icon cursor-pointer w-[38px] h-[38px]"
        onClick={openLeftDrawer}
      />
      {is1280 && (
        <div className="flex justify-center items-center gap-2">
          {headerNavigationData.map(({ ...item }, index) => (
            <HeaderNavigationItem {...item} key={index} counterValue={getCounerValue(item.path)} />
          ))}
        </div>
      )}
    </div>
  );
};

export const HeaderNavigation = memo(_HeaderNavigation);

function useGetCountOfTournaments() {
  const { tournaments: localTournaments } = useGetLocalTournaments();
  const { tournaments: providerTournaments } = useGetProviderTournaments();

  const allTournaments = useMemo(
    () => localTournaments && localTournaments?.active?.length + providerTournaments?.length,
    [localTournaments, providerTournaments?.length]
  );

  return allTournaments;
}
